module.exports = __webpack_public_path__ + "img/tz.7f8345f8.svg";